module.exports = __webpack_public_path__ + "img/Ranking-banner1@2x.49ff1e6a.png";